<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.client'> {{(parseInt(this.client.type) === 1) ? (this.client.first_name + ' ' + this.client.last_name) : ((parseInt(this.client.type) === 2) ? this.client.company_name : '')}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update client'])">
                <router-link :to="`/clients/${client.id}/edit`">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper" v-if="!input_field.personType || parseInt(input_field.personType) === parseInt(client.type)">
                                    <div class="contact-design">
                                      <i :class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i v-bind:class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-md-12" v-if="this.client.user_type">
                    <div class="location-header">
                        <h4> {{$t('txt.selecteazaTipClient')}} </h4>
                    </div>
                    <ul class="subtype-view-list">
                        <li class="subtype-list-item" v-for="types in this.client.user_type" :key="types.id">
                            <i class="fas fa-user-tag"></i>
                            <span>{{types.types.type}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-md-12">
                    <div class="location-header">
                        <h4> {{$t('txt.selecteazaDataScadentaClient')}} </h4>
                    </div>
                    <ul class="subtype-view-list" v-if="client.due_date">
                        <li class="subtype-list-item">
                            <i class="fas fa-calendar-day"></i>
                            <span>{{this.client.due_date}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="location-header">
                        <h4 id="scroller"> {{$t('txt.locatii')}} </h4>
                    </div>
                    <div class="location-wrapper animated-section" v-if="this.client">
                        <div class="location-wrapper-inner" id="location-list-container">
                            <sequential-entrance fromTop delay="70">
                                <div class="location-box" v-for="location in this.client.locations" :key="location.id">
                                    <ul class="location-inner-list">
                                        <li>
                                            <h4> {{$t('placeholder.denumireLocatie')}} </h4>
                                            <p> {{location.name ? location.name : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.adresa')}} </h4>
                                            <p> {{ fullAddress(location) }} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.linkGoogleMaps')}} </h4>
                                            <p> {{location.link_map ? location.link_map: '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.persoanaContact')}} </h4>
                                            <p> {{location.contact_pers ? location.contact_pers : '-' }} </p>
                                        </li>
                                    </ul>
                                </div>
                            </sequential-entrance>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4 id="scroller2"> {{$t('txt.persoaneContact')}} </h4>
                    </div>
                    <div class="contact-person-wrapper animated-section2" v-if="this.client">
                        <div class="contact-wrapper-inner" id="contact-list-container">
                            <sequential-entrance fromTop delay="70">
                                <div class="contact-person-box" v-for="contact in this.client.contacts"
                                     :key="contact.id">
                                    <ul class="contact-inner-list">
                                        <li>
                                            <h4> {{$t('placeholder.nume')}} </h4>
                                            <p> {{contact.name ? contact.name : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.functie')}} </h4>
                                            <p> {{contact.function ? contact.function : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.email')}} </h4>
                                            <p> {{contact.email ? contact.email : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.telefon')}}: </h4>
                                            <p> {{contact.phone ? contact.phone : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.notite')}}: </h4>
                                            <p> {{contact.notes ? contact.notes : '-'}} </p>
                                        </li>
                                    </ul>
                                </div>
                            </sequential-entrance>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.documente')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div class="inner-location-group doc-group">
                        <div class="documents-list" v-if="this.client">
                            <div class="document-box" v-for="file in this.client.files" :key="file.id">
                                <div class="document-content">
                                    <i class="far fa-file-alt"></i>
                                    <section v-if="mimes.includes(file.mime)">
                                        <a v-bind:href="file.link" target="_blank"> {{ file.file_name }} </a>
                                    </section>
                                    <section v-else>
                                        <a :href="file.link" download> {{ file.file_name }} </a>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea name='notes' disabled v-model="this.client.notes"> </textarea>
                        <div class="save-contact-buttons">
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="this.client && !this.client.is_transformed_in_contact">
                    <div class="save-as-contact">
                        <button type="button" @click='saveAsContact()' :disabled="this.$store.state.loading">
                            <i class="fas fa-save"></i>
                            {{$t('txt.salveazaCaSiContact')}}
                        </button>
                    </div>
                </div>
<!--                <div class="col-12" v-if="this.vtps">-->
<!--                    <div class="location-header">-->
<!--                        <h4> {{$t('placeholder.vtps')}} </h4>-->
<!--                    </div>-->
<!--                    <div class="vtp-checks">-->
<!--                        <ul>-->
<!--                            <div class="vtp-container" v-for="vtp in this.vtps" :key="vtp.id">-->
<!--                                <div class="vtp-list">-->
<!--                                    <span> {{vtp.start_date}} </span>-->
<!--                                    <span> - {{vtp.product.name}}</span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.vtps')}} </h4>
                    </div>
                </div>
                <table class="table app_table">
                    <thead>
                        <tr class="app_table_header">
                            <th scope="col">
                                {{$t('tableHeader.numePartener')}}
                            </th>
                            <th scope="col">
                                {{$t('tableHeader.numeProdus')}}
                            </th>
                            <th scope="col">
                                {{$t('tableHeader.data')}}
                            </th>
                            <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
                        </tr>
                    </thead>
                    <tbody v-if="this.vtps">
                        <tr  v-for="vtp in this.vtps" :key="vtp.id">
                            <td :tableheadData="$t('tableHeader.numePartener')"> {{vtp.partner_model.first_name}} {{vtp.partner_model.last_name}} </td>
                            <td :tableheadData="$t('tableHeader.numeProdus')"> {{vtp.product.name}} </td>
                            <td :tableheadData="$t('tableHeader.data')"> {{vtp.start_date}} </td>
                            <td :tableheadData="$t('tableHeader.optiuni')" class="options-case">
                                <router-link :to="{ name: 'viewvtp', params: { id: vtp.id }}" class="view-user"
                                             data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                                    <i class="fas fa-eye"></i>
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td colspan="8" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                        <td colspan="8" v-else>{{$t('errors.emptyResult')}}</td>
                    </tr>
                    </tbody>
                    <tfoot v-if="this.vtps">
                    <tr class="app_table_header">
                        <th scope="col">
                            {{$t('tableHeader.numePartener')}}
                        </th>
                        <th scope="col">
                            {{$t('tableHeader.numeProdus')}}
                        </th>
                        <th scope="col">
                            {{$t('tableHeader.data')}}
                        </th>
                        <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </form>
    </div>
</template>

<script>
import ClientsService from '../../api-services/clients.service.js'

export default {
  name: 'ViewClient',
  data () {
    return {
      client: {
        id: null,
        type: null,
        first_name: null,
        last_name: null,
        company_name: null,
        email: null,
        phone: null,
        county: null,
        city: null,
        address: null,
        cui: null,
        nr_reg: null,
        bank: null,
        site: null,
        delegat: null,
        date_corespondenta: null,
        notes: null,
        has_account: null,
        is_transformed_in_contact: null,
        locations: null,
        contacts: null,
        files: null,
        partner: null,
        employee: null
      },
      vtps: [],
      mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    }
  },
  methods: {
    getVtps (id) {
      ClientsService.getVtps(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.vtps = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    getClient () {
      ClientsService.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.client = response.data.data
          this.getVtps(this.$route.params.id)
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    saveAsContact () {
      ClientsService.transformInContact(this.$route.params.id)
        .then((response) => {
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.contactAdaugat'),
            'animation-type': 'css'
          })
          this.client = response.data.data
          window.scrollTo(0, 0)
        })
        .catch((error) => {
          console.log(error)
          this.$notify({
            group: 'error',
            type: 'error',
            title: this.$t('errors.errorTitle'),
            text: error.response.data.error,
            'animation-type': 'css'
          })
        })
    }
  },
  computed: {
    input_fields () {
      let output = {
        column_1: [
          {
            inputName: 'type',
            labelName: this.$t('txt.tipulDePersoana'),
            inputValue: (this.client) ? (parseInt(this.client.type) === 2) ? this.$t('txt.persJuridica') : this.$t('txt.persFizica') : null,
            icon: 'fas fa-user-tag'
          },
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.client) ? this.client.first_name : null,
            icon: 'fas fa-signature',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: (this.client) ? this.client.last_name : null,
            icon: 'fas fa-signature',
            personType: 1
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: (this.client) ? this.client.cnp : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            inputValue: (this.client) ? this.client.ci_series : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            inputValue: (this.client) ? this.client.ci_number : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.client) ? this.client.company_name : null,
            icon: 'fas fa-building',
            personType: 2
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.client) ? this.client.phone : null,
            icon: 'fas fa-phone'
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: (this.client) ? this.client.cui : null,
            icon: 'fas fa-scroll',
            personType: 2
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.client) ? this.client.nr_reg : null,
            icon: 'fas fa-cash-register',
            personType: 2
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: (this.client) ? this.client.bank : null,
            icon: 'fas fa-piggy-bank'
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.client && this.client.county) ? this.client.county.name : null,
            icon: 'fas fa-city'
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: (this.client && this.client.city) ? this.client.city.name : null,
            icon: 'fas fa-city'
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.client) ? this.client.address : null,
            icon: 'fas fa-map-marker-alt'
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.client) ? this.client.email : null,
            icon: 'fas fa-envelope'
          },
          {
            inputName: 'delegat',
            labelName: this.$t('placeholder.delegat'),
            inputValue: (this.client) ? this.client.delegat : null,
            icon: 'fas fa-user-tie'
          },
          {
            inputName: 'date_corespondenta',
            labelName: this.$t('placeholder.dateDeCorespondenta'),
            inputValue: (this.client) ? this.client.date_corespondenta : null,
            icon: 'fas fa-info'
          },
          {
            inputName: 'site',
            labelName: this.$t('placeholder.siteWeb'),
            inputValue: (this.client) ? this.client.site : null,
            icon: 'far fa-window-maximize'
          },
          {
            inputName: 'created_at',
            labelName: this.$t('txt.dataAdaugare'),
            inputValue: (this.client) ? this.client.created_at : null,
            icon: 'fas fa-calendar-alt'
          }
        ]
      }
      if (this.$hasRole(['admin'])) {
        output.column_2.push({
          inputName: 'partner',
          labelName: this.$t('txt.partner'),
          inputValue: (this.client && this.client.partner) ? this.partnerName(this.client.partner) : null,
          icon: 'fas fa-user-tag',
          validationRules: ''
        })
        output.column_2.push({
          inputName: 'employee',
          labelName: this.$t('txt.angajat'),
          inputValue: (this.client && this.client.employee) ? this.partnerName(this.client.employee) : null,
          icon: 'fas fa-user-tag',
          validationRules: ''
        })
      } else if (this.$hasRole(['employee'])) {
        output.column_2.push({
          inputName: 'partner',
          labelName: this.$t('txt.partner'),
          inputValue: (this.client && this.client.partner) ? this.partnerName(this.client.partner) : null,
          icon: 'fas fa-user-tag',
          validationRules: ''
        })
      }
      return output
    }
  },
  created () {
    this.getClient()
  }
}
</script>
